<template>
  <div>
      <router-link tag="span" class="cursor-pointer" v-for="(tag, index) in storyTags" :key="index" :to="storyFilter == tag.value ? `${baseUrl}/all` : `${baseUrl}/${tag.value}`">
          <!-- TODO: hidden -->
          <!-- <div class="ml-1 h-3 w-3 rounded-full mr-4" :class="'border-2 border-solid border-' + tag.color" /> -->
          <vs-chip class="ml-1 mt-1" :color="storyFilter == tag.value ? 'primary' : ''"><vs-avatar icon-pack="feather" :icon="tag.iconFeather" color="dark" /><span>{{ tag.text }}</span></vs-chip>
      </router-link>
    </div>
</template>
<script>
export default{
  data () {
    return {
      storyFilters: [
        { filterName: 'Starred', filter: 'starred', icon: 'StarIcon' },
        // { filterName: 'Trashed', filter: 'trashed', icon: 'TrashIcon' }
      ]
    }
  },
  computed: {
    storyTags () {
      return this.$store.state.story.storyTags
    },
    storyFilter () {
      return this.$route.params.filter
    },
    baseUrl () {
      const path = this.$route.path
      return path.slice(0, path.lastIndexOf('/'))
    }
  }
}
</script>
